import { useUIStore } from '@/config/stores/ui-store';
import { Authorize } from '@/shared/components/authorize';
import { Reply } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import type { FC } from 'react';
import type { Message } from '../../models/message';

interface ReplyMenuItemProps {
  msg: Message;
  onClose: () => void;
}

export const ReplyMenuItem: FC<ReplyMenuItemProps> = ({ msg, onClose }) => {
  const { setReplyMessage } = useUIStore();

  const handleReply = () => {
    setReplyMessage(msg.conversationId, msg);
    onClose();
  };

  return (
    <Authorize conversationId={msg.conversationId} permissions={['MESSAGE_SEND']}>
      <MenuItem onClick={handleReply}>
        <ListItemIcon>
          <Reply />
        </ListItemIcon>
        <ListItemText>Trả lời</ListItemText>
      </MenuItem>
    </Authorize>
  );
};
